import PropTypes from 'prop-types';
import ReactDOM from "react-dom";
import { Overlay, Container, Footer } from './styles';
import Button from '../Button';

export default function Modal({ title, body, danger, onConfirm, onCancel, isVisible }) {

  function handleCancel() {
    onCancel();
  }

  if (!isVisible) {
    return null;
  }

  return ReactDOM.createPortal(
    <>
      <Overlay>
        <Container danger={danger}>
          <h1>
            {title}
          </h1>
          <p>
            {body}
          </p>

          <Footer>
            <Button
              type='button'
              className='cancel-button'
              onClick={handleCancel}
            >
              Cancelar
            </Button>
            <Button
              type='button'
              danger={danger}
              onClick={onConfirm}
            >
              Confirmar
            </Button>
          </Footer>

        </Container>
      </Overlay>
    </>,
    document.getElementById('modal-root')
  );
}

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  isVisible: PropTypes.bool,
  danger: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

Modal.defaultProps = {
  danger: false,
  isVisible: false,
}